import { derinApiClient } from "./setup";
import { DerinApiResponse, Survey, SurveyStatus } from "./interface";

export interface CreateSurveyRequest {
  survey_content: string;
  organization_id?: string;
}

export const createSurvey = async (data: CreateSurveyRequest): Promise<void> => {
  await derinApiClient().post("/survey", data);
};

export const getSurveysByOrganization = async (organizationId: string): Promise<Survey[]> => {
  const response = await derinApiClient().get<DerinApiResponse<Survey[]>>(
    `/survey/organization/${organizationId}`
  );
  return response.data.data;
};

export interface UpdateSurveyStatusResponse {
  original_survey_id: string;
  status: SurveyStatus;
  is_active: boolean;
}

export const updateSurveyStatus = async (
  originalSurveyId: string,
  organizationId: string,
  status: SurveyStatus
): Promise<UpdateSurveyStatusResponse> => {
  const response = await derinApiClient().patch<DerinApiResponse<UpdateSurveyStatusResponse>>(
    `/survey/${originalSurveyId}/status`,
    { status },
    { params: { organization_id: organizationId } }
  );
  return response.data.data;
};

export interface NotifySurveyCreationRequest {
  surveyName: string;
  organizationId: string;
}

export const notifySurveyCreation = async (
  data: NotifySurveyCreationRequest
): Promise<void> => {
  await derinApiClient().post("/survey/notify-survey-creation", data);
};
